import { Alert } from '@mui/material';
import { ParsedStatusesFrontend } from '../../utils/types';
import { APP_DISPLAY_NAMES } from '../../utils/consts';

const HelpfulAlerts = ({
  healthData,
}: {
  healthData: ParsedStatusesFrontend;
}) => {
  const { problemApps, overallStatus } = healthData;

  if (overallStatus === 'unknown') {
    return null;
  } else if (overallStatus === 'good') {
    return <Alert severity="success">No Issues Detected</Alert>;
  } else if (problemApps.length > 1) {
    return (
      <>
        {problemApps.map(app => {
          return (
            <Alert
              sx={{ mb: 1 }}
              severity="warning"
              key={app}
              data-testid="alertBanner"
            >
              Issues Detected in {APP_DISPLAY_NAMES[app]}
            </Alert>
          );
        })}
      </>
    );
  } else {
    console.error('issue with rendering helpful alerts');
    return null;
  }
};

export default HelpfulAlerts;
